import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators, FormsModule } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialogModule as MatDialogModule
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { LocalStorageService } from '../../connectors/localstorage';
import { ModalSuccessComponent } from '../modal-success/modal-success.component';
import { ViewDetailsLoaderComponent } from '../view-details-loader/view-details-loader.component';
import { RequesSetupService } from '../../services/request-setup.service';
import { UserBehaviorService } from '../../services/user-events/user-behavior.service';
import { UsersService } from '../../services/users.service';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-modal-details-setup',
  templateUrl: './modal-details-setup.component.html',
  styleUrls: ['./modal-details-setup.component.css'],
  standalone: true,
  imports: [
    NgFor,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    NgIf,
    MatSlideToggleModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class ModalDetailsSetupComponent implements OnInit {
  email = new FormControl('', [Validators.required, Validators.email]);
  creationDate: any;
  createdBy: any;
  roleAcess: any;
  action: any;
  editMode: boolean = false;
  modalClose = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private serviceLocalStorage: LocalStorageService,
    private requestService: RequesSetupService,
    private userService: UsersService,
    private userBehavior: UserBehaviorService
  ) {}

  async ngOnInit(): Promise<void> {
    this.getRoleAcess();
    const user = await this.userBehavior.fromBehavior();
  }

  getRoleAcess() {
    this.roleAcess = this.serviceLocalStorage.decryptAndGet('roles-access');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  edit(edit: any) {
    if (edit.title.toLowerCase() !== 'ok') {
      this.editMode = true;
      this.updateDisabled(this.data.modal, false);
      this.action = edit.action;
    } else if (edit.title.toLowerCase() === 'ok') {
      this.closeDialog();
    }
  }

  updateDisabled(obj: any, state: boolean) {
    if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (
            key === 'disabled' ||
            (obj['type'] == 'flag' && key !== 'title' && key !== 'statusFlag' && key !== 'value')
          ) {
            obj[key] = state;
          } else {
            this.updateDisabled(obj[key], state);
          }
        }
      }
    }
  }

  actionEdit(action: any) {
    if (action.title.toLowerCase() === 'cancel') {
      this.editMode = false;
      this.updateDisabled(this.data.modal, true);
    } else if (action.type.toLowerCase() === 'save-team') {
      const fieldToBodyMap = { teamName: 'Team Name' };
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap);
    } else if (action.type.toLowerCase() === 'save-role') {
      const fieldToBodyMap = { roleName: 'Role Name', statusFlag: 'statusFlag' };
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap);
    } else if (action.type.toLowerCase() === 'save-user') {
      const fieldToBodyMap = { userName: 'User Name', emailAddress: 'Email' };
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap);
    } else if (action.type.toLowerCase() === 'save-priority') {
      const fieldToBodyMap = { priorityName: 'Priority Name' };
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap);
    }
  }

  save(path: any, body: any, fieldToBodyMap: { [fieldKey: string | number]: string | number }) {
    for (const fieldKey in fieldToBodyMap) {
      if (fieldToBodyMap.hasOwnProperty(fieldKey)) {
        const field = this.data.modal.fields.find((field: any) => field.title === fieldToBodyMap[fieldKey]);
        if (field) {
          body[fieldKey] = field.value;
        }
      }
    }
    body.statusFlag = this.data.modal.toggles[0].value === true ? 1 : 0;
    body.updatedBy = this.data.modal.idUser;
    this.actionSetup(path, body);
  }

  actionSetup(path: any, body: any) {
    this.requestService.actionSetup(path, body).subscribe((resp: any) => {
      this.data.modal.fields.forEach((field: any) => {
        field.value = [''];
      });
      this.fecharModal();
      this.openSuccessModal();
      this.closeDialog();
    });
  }

  openProgressDialog(text: any): Promise<void> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ViewDetailsLoaderComponent, {
        autoFocus: false,
        closeOnNavigation: true,
        disableClose: true,
        height: '250px',
        width: '600px',
        panelClass: 'center-modal',
        data: { modalClose$: this.modalClose, text: text }
      });

      dialogRef.afterOpened().subscribe(() => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    });
  }

  openSuccessModal() {
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      autoFocus: false,
      closeOnNavigation: true,
      disableClose: true,
      height: '250px',
      width: '700px',
      panelClass: 'center-modal'
    });

    dialogRef.afterOpened().subscribe(() => {});
  }

  fecharModal() {
    this.modalClose.next(true);
  }
}
